<template>
    <div class="mx-auto">
        <b-modal
                ref="modal-comunicacao-transferencia-ef-sefa"
                id="modal-comunicacao-transferencia-ef-sefa"
                size="xl"
                :content-class="'shadow ' + getTheme"
                :title="'Requisição n. ' + itemCarregado.numeroRequisicao"
                header-bg-variant="success"
                header-text-variant="white"
                @hidden="close">
            <template #modal-header="{ close }">
                <h5 class="modal-title">{{ 'Requisição n. ' + itemCarregado.numeroRequisicao }}</h5>
                <b-button variant="success" @click="relatorioPDF" class="py-0 ml-auto"> <i class="far fa-file-pdf"></i> Imprimir</b-button>
                <button class="close text-white ml-1" @click="close()" aria-label="close">&times;</button>
            </template>
            <b-row>
                <b-col xs="12" md="12" class="mx-auto">
                    <div id="messages" v-if="messageModal.message !== null">
                        <b-alert show :variant="messageModal.variant">{{ messageModal.message }}</b-alert>
                    </div>
                </b-col>
                <b-col xs="12" md="12" class="mx-auto">
                    <b-card>
                        <b-tabs card active-nav-item-class="text-title-selected" v-model="tabIndex">
                            <b-tab title="Dados Básicos" active title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Tipo da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ requisicaoComTransfEfSefa.tipoRequisicao }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Data de Criação:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.dataCriacao }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Status Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p :style="'color: ' + requisicaoComTransfEfSefa.corStatus">{{ requisicaoComTransfEfSefa.status }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Forma de Pgto.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.formaPagamento }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Tipo de Pgto:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.tipoPagamento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Modalidade Parc.:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.modalidadeParcelamento }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Qtde. Parcelas:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p v-if="requisicaoComTransfEfSefa.tipoPagamento != 'À Vista'">{{ requisicaoComTransfEfSefa.quantidadeParcelas }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Vlr. da Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>R$ {{ requisicaoComTransfEfSefa.valor | currency }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Percentual Pago:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.percentualPago }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Origem Requisição:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.origem }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Índice de Reajuste:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.indiceReajuste }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Setor Emitente:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.setor }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>REFIS:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.refis }}</p>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Observações:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <pre><p class="texto-scroll" v-html="requisicaoComTransfEfSefa.observacoes"></p></pre>
                                    </b-col>
                                </b-row>
                                <hr class="mt-3"/>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="3" md="2">
                                        <label>Docs. Anexados:</label>
                                    </b-col>
                                    <b-col sm="6" md="7">
                                        <span v-for="anexo in requisicaoComTransfEfSefa.anexos" :key="anexo.codAnexo">
                                        <p>
                                            <a class="link" @click="obterAnexo(anexo)">
                                                {{ anexo.nomeAnexo }}
                                            </a>
                                            <b-button class="ml-2" v-if="perfilAdministrador"
                                                    variant="outline-warning"
                                                    @click="removerAnexo(anexo)">
                                                <i class="fa fa-trash"></i>
                                            </b-button>
                                        </p>
                                        </span>
                                    </b-col>
                                    <b-col sm="3" md="3">
                                        <b-button variant="outline-warning" @click="incluirAnexo" class="float-right"> <i class="fa fa-paperclip fa-flip-horizontal"></i> Anexar Arquivo</b-button>
                                        <b-form-file v-show="false" @input="realizarUpload" ref="incluir-anexo"></b-form-file>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Devedor" title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Devedor:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.nome }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>CPF/ CNPJ:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.documento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>E-mail principal:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.email }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Celular:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.telefone }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Endereço:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.logradouro }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Nº:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.numero }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Complemento:</label>
                                    </b-col>
                                    <b-col sm="6" md="10">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.complemento }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Cidade:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.municipio != null ? requisicaoComTransfEfSefa.contribuinte.municipio.nome : '' }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Estado:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.uf != null ? requisicaoComTransfEfSefa.contribuinte.uf.nome : '' }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>CEP:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.contribuinte.cep }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="12">
                                        <b-button variant="outline-primary" style="float: right;" @click="atualizarCadastro">
                                            <i class="far fa-address-book fa-flip-horizontal icon-button align-middle"></i> Abrir Cadastro do Devedor
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-tab>
                            <b-tab title="Cálculo" title-link-class="text-title">
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Base de Cálculo:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.baseCalculo }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Valor Base:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.valorBase }}</p>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Percentual:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.percentual }}</p>
                                    </b-col>
                                    <b-col sm="6" md="2">
                                        <label>Valor Calculado:</label>
                                    </b-col>
                                    <b-col sm="6" md="4">
                                        <p>{{ requisicaoComTransfEfSefa.valorCalculado }}</p>
                                    </b-col>
                                </b-row>

                                <hr class="mt-4"/>

                                <b-row class="mt-1 mb-0">
                                    <b-col>
                                        <label>CDA (EF) - Valor de Base (VB) - Honorários (rateio):</label>
                                    </b-col>
                                </b-row>

                                <b-row class="mb-0 overflow-grid-extrato">
                                    <b-col md="12" style="padding-left: 30px;" v-for="cda in requisicaoComTransfEfSefa.cdas">
                                        <label>{{cda}}</label>
                                    </b-col>
                                </b-row>

                                <b-button
                                        id="btnRelatorioDeducoes"
                                        class="ml-2"
                                        variant="outline-warning"
                                        style="height: 40px;float: right;margin-top: 10px;"
                                        v-if="requisicaoComTransfEfSefa.possuiDeducoes"
                                        @click="relatorioDeducoesPDF()">
                                    <i class="fa fa-eye"></i> Ver Relatório de Deduções
                                </b-button>
                                <b-button
                                        id="btnRelatorioDeducoesSem"
                                        class="ml-2"
                                        variant="outline-warning"
                                        style="height: 40px;float: right;margin-top: 10px;"
                                        v-b-modal.modal-alerta-deducoes-com-ef-sefa
                                        v-if="!requisicaoComTransfEfSefa.possuiDeducoes">
                                    <i class="fa fa-eye"></i> Ver Relatório de Deduções
                                </b-button>
                            </b-tab>
                            <b-tab title="Pagamento(s)" title-link-class="text-title" v-if="requisicaoComTransfEfSefa.status != 'Encaminhada CES'">
                                <b-row sm="12" md="12" class="d-block">
                                    <b-button variant="outline-primary" @click="enviarEmail" class="mr-2"
                                        :title="`Enviar boleto e documentação ao devedor`"
                                    >
                                        <i class="far fa-envelope"></i> Enviar por E-mail
                                    </b-button>
                                    <b-button variant="secondary" v-b-modal.modal-cancelar-com-ef-sefa :disabled="desabilitarCancelarEditar()" class="float-right"
                                        title="O botão Cancelar a Requisição permite o cancelamento da Requisição gerada cuja situação seja Aguardando Validação.">
                                        <i class="fa fa-trash"></i> Cancelar a Requisição
                                    </b-button>
                                    <b-button variant="warning" class="mr-2 float-right" @click="alterarHonorarios" :disabled="desabilitarCancelarEditar()" v-if="exibirEditar"
                                        title="O botão Editar a Requisição permite editar os parâmetros da Requisição gerada cuja situação seja Aguardando Validação.">
                                        <i class="fa fa-pen"></i> Editar a Requisição
                                    </b-button>
                                </b-row>
                                <b-row class="mt-3 mb-0">
                                    <b-col sm="6" md="2">
                                        <label>Transferência:</label>
                                    </b-col>
                                </b-row>
                                <b-row class="mt-1 mb-0 overflow-grid-extrato">
                                    <b-table
                                            id="pagamentos"
                                            ref="tablePagamentos"
                                            :items="getItensPagamento"
                                            :fields="fieldsTransferencia"
                                            striped
                                            small
                                            responsive="sm"
                                            :busy="false"
                                            show-empty
                                            hover
                                            bordered
                                            sort-icon-left
                                            class="mb-0 col-12 tabelaModal"
                                            head-variant="light">
                                        <div slot="table-busy" class="text-center text-primary my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <strong> Carregando...</strong>
                                        </div>
                                        <template slot="empty">
                                            <p class="my-auto">Nenhum tipo de pagamento encontrado.</p>
                                        </template>
                                        <template v-slot:cell(valor)="{ item }">
                                            {{ item.valor | currency }}
                                        </template>
                                    </b-table>
                                </b-row>
                            </b-tab>
                        </b-tabs>
                    </b-card>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-secondary mr-auto" @click=hide()> <i class="fa fa-reply"></i> Voltar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-cancelar-com-ef-sefa"
                id="modal-cancelar-com-ef-sefa"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Cancelar a Requisição"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Deseja cancelar a requisição?</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-cancelar-com-ef-sefa')"> Não</b-button>
                <b-button variant="primary" @click="cancelarRequisicao"> Sim</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-alerta-deducoes-com-ef-sefa"
                id="modal-alerta-deducoes-com-ef-sefa"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Requisição sem pagamentos anteriores deduzidos"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>A presente Requisição foi gerada sem a dedução de pagamentos anteriores.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-alerta-deducoes-com-ef-sefa')"> Voltar</b-button>
            </template>
        </b-modal>

        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="loading"
                @salvarDevedor="salvarDevedor"/>

        <ModalEnviarEmail
                ref="modalEnviarEmail"
                :anexos="requisicaoComTransfEfSefa.anexos"
                :loading="loading"
                @enviarEmail="enviarEmail"/>
    </div>
</template>

<script>
    import axios from 'axios'
    import formatarMixins from '../../../mixins/formatarMixins';
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import ModalEnviarEmail from "../../shared/components/ModalEnviarEmail"
    import CompFiltroGrid from "../../shared/components/CompFiltroGrid"

    export default {
    props: ['loading'],
    components: { ModalAlterarDevedor, ModalEnviarEmail, CompFiltroGrid },
    mixins: [ formatarMixins ],
    data() {
        return {
            updated: false,
            urlApi: null,
            token: null,
            idRequisicao: null,
            exibirEditar: false,
            perfilAdministrador: false,
            tabIndex: 0,
            dados: {
                uf: [],
                municipios: [],
            },
            messageModal: {
                message: null,
                variant: null
            },
            itemCarregado: {
                numeroRequisicao: null
            },
            requisicaoComTransfEfSefa: {
                id: null,
                numeroRequisicao: null,
                tipoRequisicao: null,
                dataCriacao: null,
                status: null,
                corStatus: null,
                formaPagamento: null,
                tipoPagamento: null,
                modalidadeParcelamento: null,
                quantidadeParcelas: null,
                valor: null,
                percentualPago: null,
                indiceReajuste: null,
                setor: null,
                refis: null,
                quitada: null,
                observacoes: null,
                baseCalculo: null,
                valorBase: null,
                percentual: null,
                valorCalculado: null,
                total: null,
                bloquearBotoesBoletoMesAnterior: null,
                contribuinte: {
                    codContribuinte: null,
                    tipoContribuinte: {
                        id: null,
                        nome: null
                    },
                    nome: null,
                    indAtivo: null,
                    documento: null,
                    telefone: null,
                    email: null,
                    cep: null,
                    logradouro: null,
                    numero: null,
                    complemento: null,
                    bairro: null,
                    uf: {
                        id: null,
                        nome: null
                    },
                    municipio: {
                        codMunicipio: null,
                        nome: null
                    },
                },
                cdas: [],
                anexos: [],
            },
            fieldsTransferencia: [
                {
                    key: 'dataTransferencia',
                    label: 'Data da Transf.'
                },
                {
                    key: 'valor',
                    label: 'Valor'
                },
                {
                    key: 'validadoSetor',
                    label: 'Validação GOFS'
                },
                {
                    key: 'validadoTesoureiro',
                    label: 'Validação Tesoureiro'
                },
                {
                    key: 'status',
                    label: 'Situação'
                }
            ],
            contribuinte: {
                nome: null,
                documento: null,
                telefone: null,
                email: null,
                cep: null,
                logradouro: null,
                numero: null,
                complemento: null,
                bairro: null,
                uf: null,
                municipio: null
            },
        }
    },
    computed: {
        getTheme () {
            return this.$store.getters.getTheme
        },
        getItensPagamento () {
            return [ this.requisicaoComTransfEfSefa ]
        }
    },
    methods: {
        abrirExtrato(item) {
            this.limparMsgsModal();

            this.idRequisicao = item.id;

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/carregarExtrato/${item.tabelaOrigem}/${item.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.itemCarregado = item;
                this.requisicaoComTransfEfSefa = response.data;
                this.pagamentosReduzidosTemp = [];
                this.$refs['modal-comunicacao-transferencia-ef-sefa'].show();

                setTimeout(()=>{
                    var tabelas = document.getElementsByClassName("tabelaModal");
                    for (let i = 0; i < tabelas.length; i++) {
                        var inner = tabelas[i].children[0].children[0];
                        inner.style.position = 'sticky';
                        inner.style.top = '-2px';
                    }
                }, 200);
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.loading.hideLoading();
            });
        },
        async obterAnexo(anexo) {
            await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
            }).then(response => {
                if(!response.data || response.data == null){
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                    return;
                }

                var a = document.createElement("a");
                a.href = response.data.base64;
                a.download = response.data.nomeArquivo;
                a.click();
            }).catch((error) => {
                this.exibirErro(error)
            });
        },

        async relatorioPDF() {
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/exportarRequisicaoComunicacaoTransfEfSefa/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
            .then(response => {
                let blob = new Blob([response.data], { type: 'application/pdf' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'requisicaoComTransfEfSefa' + this.itemCarregado.numeroRequisicao + '.pdf';
                link.click();
            }).finally(() => {
                this.loading.hideLoading();
            })
        },

        cancelarRequisicao() {
            this.$refs['modal-cancelar-com-ef-sefa'].hide();

            this.limparMsgsModal();

            if(this.requisicaoComTransfEfSefa.status != 'Aguardando Aprovação' &&
                this.requisicaoComTransfEfSefa.status != 'Aguardando Validação' &&
                this.requisicaoComTransfEfSefa.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser cancelada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/cancelarRequisicaoComunicacaoTransfEfSefa/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            }).then(response => {
                this.updated = true;
                this.abrirExtrato(this.itemCarregado);
                this.messageModal = {
                    message: 'Requisição cancelada com sucesso.',
                    variant: 'success'
                };
            }).finally(() => {
                this.loading.hideLoading();
            })
        },
        alterarHonorarios() {
            this.limparMsgsModal();

            if(this.requisicaoComTransfEfSefa.status != 'Aguardando Aprovação' &&
                this.requisicaoComTransfEfSefa.status != 'Aguardando Validação' &&
                this.requisicaoComTransfEfSefa.status != 'Pendente') {
                this.messageModal = {
                    message: 'Requisição não pode ser alterada na situação atual.',
                    variant: 'danger'
                };
                return;
            }

            if(this.$router.currentRoute.fullPath.startsWith('/comunicacao-transferencia-ef-sefa')) {
                this.$emit('obterRequisicaoComTransfEfSefa', this.itemCarregado.id, false);
                this.$refs['modal-comunicacao-transferencia-ef-sefa'].hide();
            } else {
                this.$store.commit('setRequisicaoComTransfEfSefa', this.itemCarregado.id);
                this.$router.push({path: '/comunicacao-transferencia-ef-sefa'});
            }
        },

        atualizarCadastro() {
            this.$refs.modalAlterarDevedor.atualizarCadastro(this.requisicaoComTransfEfSefa.contribuinte);
        },
        enviarEmail () {
            this.$refs.modalEnviarEmail.abrirModalEnviarEmail(this.requisicaoComTransfEfSefa)
        },
        incluirAnexo () {
            this.$refs['incluir-anexo'].$el.childNodes[0].click()
        },
        realizarUpload (arquivo) {
            this.$store.commit("setMessages", {});
            let arquivoConvertido = null
            if ((arquivo.size / 1024) / 1024 > 50.0) {
                this.messageModal = {
                    message: 'Tamanho do arquivo ultrapassa o limite definido em 50mb.',
                    variant: 'danger'
                };
            } else {
                var reader = new FileReader()
                reader.onload = function (e) {
                    arquivoConvertido = {
                        nomeArquivo: arquivo.name,
                        base64: e.target.result
                    }
                }
                reader.readAsDataURL(arquivo)
                reader.onloadend = () => this.salvarAnexo(arquivoConvertido)
            }
        },
        salvarAnexo (arquivo) {
            let parametros = {
                id: this.requisicaoComTransfEfSefa.id,
                arquivo: arquivo,
                tipoOrigem: this.requisicaoComTransfEfSefa.tipoOrigem
            }

            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/incluirAnexo`, parametros, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                let codAnexo = ((response) && (response.data)) ? response.data.id : 0
                this.requisicaoComTransfEfSefa.anexos.push({
                    codAnexo: codAnexo,
                    nomeAnexo: arquivo.nomeArquivo,
                    base64 : arquivo.base64
                })
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        removerAnexo (arquivo) {
            this.loading.showLoading()
            axios.post(`${this.urlApi}/v1/pesquisas/removerAnexo/${arquivo.codAnexo}`, null, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then((response) => {
                this.requisicaoComTransfEfSefa.anexos = this.requisicaoComTransfEfSefa.anexos.filter((anexo) => anexo.codAnexo !== arquivo.codAnexo)
                this.loading.hideLoading()
            }).catch((error) => {
                this.exibirErro(error)
                this.loading.hideLoading()
            })
        },
        salvarDevedor(contribuinte) {
            this.requisicaoComTransfEfSefa.contribuinte = {
                codContribuinte: contribuinte.codContribuinte,
                nome: contribuinte.nome,
                documento: contribuinte.documento,
                telefone: contribuinte.telefone,
                telefoneAlternativo1: contribuinte.telefoneAlternativo1,
                telefoneAlternativo2: contribuinte.telefoneAlternativo2,
                email: contribuinte.email,
                emailAlternativo1: contribuinte.emailAlternativo1,
                emailAlternativo2: contribuinte.emailAlternativo2,
                cep: contribuinte.cep,
                logradouro: contribuinte.logradouro,
                numero: contribuinte.numero,
                complemento: contribuinte.complemento,
                bairro: contribuinte.bairro,
                uf: contribuinte.uf,
                municipio: contribuinte.municipio
            };
            this.messageModal = {
                message: 'Cadastro do Devedor alterado com sucesso!',
                variant: 'success'
            };
            this.updated = true;
        },
        limparMsgsModal() {
            this.messageModal = {
                message: null,
                variant: null
            };
        },
        close() {
            this.$emit('closeModal', this.updated);
            this.updated = false;
        },
        requisicaoCancelada() {
            return this.requisicaoComTransfEfSefa != null && (this.requisicaoComTransfEfSefa.status == 'Cancelada' || this.requisicaoComTransfEfSefa.status == 'Quitada' || this.requisicaoComTransfEfSefa.status == 'Rescindido');
        },
        desabilitarCancelarEditar() {
            return this.requisicaoComTransfEfSefa != null && this.requisicaoComTransfEfSefa.status != 'Aguardando Aprovação' &&
                this.requisicaoComTransfEfSefa.status != 'Aguardando Validação' &&
                this.requisicaoComTransfEfSefa.status != 'Pendente';
        },
        async relatorioDeducoesPDF() {
            this.loading.showLoading();
            axios.get(`${this.urlApi}/v1/pesquisas/exportarDeducoes/${this.requisicaoComTransfEfSefa.tipoOrigem}/${this.itemCarregado.id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                },
                responseType: 'arraybuffer'
            })
                .then(response => {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = 'requisicaoComTransfEfSefa' + this.itemCarregado.numeroRequisicao + '.pdf';
                    link.click();
                }).finally(() => {
                this.loading.hideLoading();
            })
        },
    },
    mounted() {
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        let userData = JSON.parse(this.$store.getters.getUser);
        if (userData.groups) {
            for (let i = 0; i < userData.groups.length; i++) {
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR' || userData.groups[i] == 'SFEPGE-TESOUREIRO') {
                    this.exibirEditar = true;
                }
                if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
                    this.perfilAdministrador = true;
                }
            }
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
